(ns common.themes.reindeer-partners)

(def border-radiuses
  {:xxxsmall ".25rem"
   :xxsmall  ".5rem"
   :xsmall   ".625rem"
   :small    ".75rem"
   :medium   "1rem"
   :large    "2rem"
   :xlarge   "3rem"
   :round    "50%"})

(def border-widths
  {:medium "1px"
   :large  "2px"})

(def palette
  "Palette of colors for this theme."
  {:background        "#f7f6f3"
   :page-background   "#F7F6F3"
   ;; Brand colors
   :brand-1           "#532300"
   :brand-2           "#E1A13F"
   :brand-3           "#EFCEA0"

   ;; Gray scales
   :black             "#000000"
   :black-transparent "rgba(0,0,0,0.95)"
   :grey-80           "#32332F"                                                                     ;; Black
   :grey-60           "#565952"                                                                     ;; Gray
   :grey-50           "#888C81"                                                                     ;; Light grey
   :grey-40           "#F0F4F1"                                                                     ;; Lighter grey
   :grey-30           "#D9D9DA"                                                                     ;; Off-gray
   :grey-20           "#F2F2EE"                                                                     ;; Off-white
   :grey-10           "#fffefb"
   :white             "#FFFFFF"                                                                     ;; Pure white
   ;; Complementary colors
   :info              "#49667A"                                                                     ;; Blue
   :success           "#1BC9B9"                                                                     ;; Success
   :warning           "#F7AE6A"                                                                     ;; Orange
   :danger            "#FC7171"                                                                     ;; Red
   :light             "#F2F2EE"
   :dark              "#32332F"
   :blue-link         "#007BFF"
   ;;
   :transparent       "transparent"})

(def colors
  {:burger-menu      {:bg         :brand-1
                      :cross      :grey-80
                      :menu       {:bg :white}
                      :link       {:color :grey-80}
                      :link-hover {:color :brand-3}}

   :link             {:primary   {:color :brand-1}
                      :secondary {:color       :brand-2
                                  :hover-color :white}
                      :main      {:color :grey-60}
                      :border    {:color :grey-10}}

   :text-strong      {:primary   {:color :grey-80}
                      :hover     {:color :brand-2}
                      :secondary {:color :brand-3}}

   :text             {:primary   {:color :brand-1}
                      :secondary {:color :grey-60}
                      :main      {:color :grey-80}}

   :menu-item        {:primary {:bg :grey-40}}

   :dropdown         {:bg    :white
                      :color :grey-80
                      :hover {:color :black
                              :bg    :brand-1}
                      :focus {:color :black
                              :bg    :brand-1}}

   :general-border   {:border          :grey-30
                      :border-strong   :brand-1
                      :border-hover    :brand-1
                      :border-selected :brand-1
                      :caret           :grey-60}

   :figure           {:primary {:color :brand-1}}

   :upload-file      {:primary {:color :grey-50}}

   :tablebg          {:primary {:bg :white}}

   :page-bg          {:bg :background}

   :outer-container  {:primary   {:bg :transparent}
                      :secondary {:bg :white}
                      :border    :grey-40}

   :entity-row       {:bg        :white
                      :border    :grey-30
                      :row       {:bg :transparent}
                      :sort-item {:border :grey-10}}

   :container-bgr    {:primary   {:bg :white}
                      :secondary {:bg :grey-20}
                      :helper    {:bg :brand-3}}

   :footer-bgr       {:secondary  {:bg :background}
                      :separator  :black
                      :text-hover :grey-80
                      :text       :black}

   :header-bgr       {:primary   {:bg :brand-1}
                      :secondary {:bg    :transparent
                                  :color :black}}

   ;;PORTAL styles

   :sidebar-nav-link {:regular {:color  :brand-1
                                :bg     :white
                                :border :transparent}
                      :hover   {:color  :brand-2
                                :bg     :white
                                :border :brand-1}}

   :home-link        {:regular {:color  :brand-1
                                :bg     :white
                                :border :grey-30}
                      :hover   {:color :brand-2}}

   ;;Editor styles

   :icon-step        {:regular {:color :grey-50}
                      :done    {:color :brand-2}}

   :progress         {:default    {:bg :grey-30}
                      :active     {:bg :brand-1}
                      :activeText {:color :white}}

   :button           {:disabled {:link  {:bg :white
                                         :fg :grey-50}
                                 :other {:bg :grey-50
                                         :fg :white}}
                      :focus    {:other {:border :white}}
                      :regular  {:primary   {:bg :brand-1
                                             :fg :white}
                                 :secondary {:bg :grey-80
                                             :fg :white}
                                 :success   {:bg :success
                                             :fg :white}
                                 :danger    {:bg :danger
                                             :fg :white}
                                 :warning   {:bg :warning
                                             :fg :white}
                                 :info      {:bg :info
                                             :fg :white}
                                 :light     {:bg :light
                                             :fg :black}
                                 :dark      {:bg :dark
                                             :fg :white}
                                 :link      {:bg :white
                                             :fg :blue-link}
                                 :frame     {:bg :white
                                             :fg :brand-1}}}

   :card             {:card {:box-shadow :grey-30
                             :bg         :background}
                      :head {:disabled :grey-30
                             :title    :brand-1}
                      :body {:border :grey-30
                             :bg     :white
                             :link   {:regular :brand-2
                                      :hover   :brand-1}}}

   :content-card     {:body  {:bg     :white
                              :border :grey-30}
                      :row   {:border :grey-30}
                      :child {:primary   {:bg :grey-20}
                              :secondary {:bg :white}}
                      :title {:color :brand-1}}

   :checkbox         {:regular-label {:disabled :grey-30}
                      :custom-label  {:enabled  {:bg {:checked   :brand-1
                                                      :unchecked :grey-30}
                                                 :fg :black}
                                      :disabled {:bg :grey-30
                                                 :fg :black}}
                      :custom-handle {:bg :white}
                      :regular-icon  {:disabled {:fg :grey-30}
                                      :checked  {:fg :brand-1}
                                      :fg       :grey-30}
                      :text          {:custom {:fg :white}}}

   :modal-dialog     {:header        {:bg            :black
                                      :fg            :white
                                      :border-bottom :grey-20
                                      :color         :white}
                      :footer        {:border-top :grey-20}
                      :modal         :black
                      :modal-content {:bg :white}}

   :text-input       {:border {:regular :grey-30
                               :hover   :grey-80
                               :focus   :grey-80}
                      :bg     :background}

   :field-options    {:color  :black
                      :bg     :white
                      :item   {:bg     :white
                               :color  :black
                               :border :grey-30}
                      :header {:border :grey-30}}

   :select-input     {:container           {:bg     :white
                                            :border :grey-30}
                      :group-heading       {:bg :grey-30}
                      :indicator-separator :grey-30
                      :loading-indicator   :grey-30
                      :loading-message     :grey-30
                      :menu                :white
                      :multi-value         {:border :brand-1
                                            :fg     :brand-1}
                      :no-options-message  {:border :grey-30}
                      :option              {:selected   {:border-top :grey-20
                                                         :bg         :brand-1
                                                         :fg         :white}
                                            :focused    {:border-top :grey-20
                                                         :bg         :grey-30}
                                            :border-top :grey-20}
                      :placeholder         {:fg :grey-50}}

   :steps-band       {:steps-band {:border :transparent}
                      :step       {:fg          {:active :grey-10}
                                   :bg          {:completed        :brand-1
                                                 :completed-active :brand-2
                                                 :active           :brand-3}
                                   :border-left {:after {:completed        :brand-1
                                                         :completed-active :brand-2
                                                         :active           :brand-3
                                                         :next             :white}}}
                      :step-icon  {:completed        {:bg :transparent
                                                      :fg :white}
                                   :completed-active {:bg :white
                                                      :fg :grey-80}
                                   :active           {:bg :white
                                                      :fg :grey-80}
                                   :next             {:bg :transparent
                                                      :fg :grey-80}}}


   :tab-layout       {:tab-title {:regular  {:border-bottom :grey-30}
                                  :selected {:fg            :brand-2
                                             :border-bottom :brand-2}}}

   :dynamic-table    {:border   :grey-10
                      :cell     {:border :grey-10}
                      :bg       :grey-20
                      :odd-row  {:bg :white}
                      :even-row {:bg :grey-20}}

   :news-section     {:general         {:bg    :brand-1
                                        :color :white}
                      :dropdown        {:color      :white
                                        :background :transparent
                                        :border     :white
                                        :outline    :brand-2}
                      :dropdown-option {:color :grey-80}
                      :show-all        {:default {:color :white}
                                        :hover   {:color :brand-2}}}
   :table            {:border :grey-30
                      :tr     {:even            :white
                               :odd             :grey-10
                               :subheading      :brand-1
                               :subheading2     :brand-3
                               :subheading-text :dark}
                      :th     {:bg            :brand-3
                               :fg            :white
                               :border-bottom :grey-20}}


   :chart            {:waterfall {:line  :grey-40
                                  :start :grey-60
                                  :sum   :grey-60
                                  :up    :brand-2
                                  :down  :danger}
                      :bar-chart {:grid {:line :grey-40}}}
   :lp-report        {:big-figures      {:pdf {:border :grey-10
                                               :value  :brand-1
                                               :label  :brand-1}}
                      :chart            {:x-axis      {:line      :grey-40
                                                       :grid-line :grey-40}
                                         :y-axis      {:line      :grey-40
                                                       :grid-line :grey-40}
                                         :waterfall   {:sum   :brand-3
                                                       :up    :success
                                                       :down  :brand-1
                                                       :color :brand-1}
                                         :multi-chart {:ordered-default-colors {:color-1 :brand-1   ;; NOTE: can add more colors
                                                                                :color-2 :brand-2
                                                                                :color-3 :brand-3
                                                                                :color-4 :success}}
                                         :map         {:highlighted-countries     {:color :brand-1}
                                                       :non-highlighted-countries {:color :brand-2}
                                                       :hover                     {:color :brand-3}
                                                       :label                     {:color :white}}}
                      :table            {:font-color         :black
                                         :even-row           {:bg :white}                           ;;NOTE use this for coloring all the tables, web and pdf
                                         :odd-row            {:bg :grey-20}
                                         :heading-color      {:bg :brand-1}
                                         :heading-info-color {:bg :brand-2}
                                         :subheading-color   {:bg :white}
                                         :subtotal-color     {:bg :white}
                                         :total-color        {:bg :white}
                                         :empty-line-color   {:bg :white}
                                         :pdf                {:even-row           {:bg :white}
                                                              :odd-row            {:bg :grey-20}
                                                              :heading-color      {:bg :brand-1}
                                                              :heading-info-color {:bg :brand-2}
                                                              :subheading-color   {:bg :white}
                                                              :subtotal-color     {:bg :white}
                                                              :total-color        {:bg :white}
                                                              :empty-line-color   {:bg :white}
                                                              :heading-border     :grey-20}}
                      :horizontal-table {:heading  {:background :white}
                                         :even-row {:bg :white}
                                         :odd-row  {:bg :grey-20}
                                         :pdf      {:even-row           {:bg :white}
                                                    :odd-row            {:bg :grey-20}
                                                    :heading-color      {:bg :brand-1}
                                                    :heading-info-color {:bg :brand-2}
                                                    :subheading-color   {:bg :white}
                                                    :subtotal-color     {:bg :white}
                                                    :total-color        {:bg :white}
                                                    :empty-line-color   {:bg :white}}}
                      :vertical-table   {:even-row {:bg :white}
                                         :odd-row  {:bg :grey-30}
                                         :pdf      {:even-row           {:bg :white}
                                                    :odd-row            {:bg :grey-20}
                                                    :heading-color      {:bg :grey-50}
                                                    :heading-info-color {:bg :grey-30}
                                                    :subheading-color   {:bg :white}
                                                    :subtotal-color     {:bg :white}
                                                    :total-color        {:bg :white}
                                                    :empty-line-color   {:bg :white}}}
                      :block-table      {:even-row {:bg :white}
                                         :odd-row  {:bg :grey-20}
                                         :pdf      {:even-row           {:bg :white}
                                                    :odd-row            {:bg :grey-20}
                                                    :heading-color      {:bg :grey-50}
                                                    :heading-info-color {:bg :grey-30}
                                                    :subheading-color   {:bg :white}
                                                    :subtotal-color     {:bg :white}
                                                    :total-color        {:bg :white}
                                                    :empty-line-color   {:bg :white}}}}


   :pdf              {:table         {:odd-color     :background
                                      :even-color    :white
                                      :heading-color :brand-1}
                      :color         :grey-40
                      :color-dark    :grey-80
                      :border        :grey-10
                      :header-border :grey-20
                      :total-border  :grey-40
                      :column        {:color :grey-80}
                      :fill          :background}
   })


(def edge-sizes
  "Margins and paddings"
  {:xxxsmall "0.25rem"
   :xxsmall  "0.5rem"
   :xsmall   "0.75rem"
   :small    "1rem"
   :medium   "1.25rem"
   :large    "1.5rem"
   :xlarge   "1.875rem"
   :xxlarge  "2.5rem"
   :xxxlarge "3.125rem"})

(def font-weights
  {:regular   400
   :medium    500
   :semi-bold 600
   :bold      700})

(def text-sizes
  "text-size/size corresponds to CSS `font-size`
  text-size/height corresponds to CSS `line-height`"
  {:xxxsmall {:size   ".625rem"
              :height "1.4"}
   :xxsmall  {:size   ".75rem"
              :height "1.4"}
   :xsmall   {:size   ".875rem"
              :height "1.5"}
   :small    {:size   "1rem"
              :height "1.5"}
   :medium   {:size   "1.25rem"
              :height "1.5"}
   :large    {:size   "1.75rem"
              :height "1.6"}})

(def font-families
  {:palatino "Palatino LT Pro"
   :gothic   "News Gothic MT"})

(def theme
  {:border-radiuses border-radiuses
   :border-widths   border-widths
   :colors          colors
   :edge-sizes      edge-sizes
   :font-weights    font-weights
   :palette         palette
   :text-sizes      text-sizes
   :font-families   font-families})
